module.exports = __webpack_public_path__ + "img/murloc_small.4811ff90.png";